import { PERISCOPE_PICKLIST_COPY } from '@sonar-software/sonar-ts-constants';
import { PeriscopeTablessContent } from '../../../general';
import { usePeriscopeActions } from '@hooks';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
export const PicklistValueScope = ({ data, index }) => {
    const { openPeriscope } = usePeriscopeActions();
    const { parentField, parentEntity } = data;
    const handleFieldClick = useCallback(() => {
        openPeriscope({
            id: parentField.sonarObjectId,
            name: parentField.displayName,
            openedFromIndex: index,
            type: SonarObjectType.SalesforceField
        });
    }, [index, openPeriscope, parentField.displayName, parentField.sonarObjectId]);
    const handleEntityClick = useCallback(() => {
        openPeriscope({
            id: parentEntity.sonarObjectId,
            name: parentEntity.displayName,
            openedFromIndex: index,
            type: SonarObjectType.SalesforceEntity
        });
    }, [index, openPeriscope, parentEntity.displayName, parentEntity.sonarObjectId]);
    return (React.createElement(PeriscopeTablessContent, null,
        PERISCOPE_PICKLIST_COPY.DESCRIPTION_PREFIX,
        React.createElement("b", { className: 'clickable', onClick: handleFieldClick }, parentField.displayName),
        PERISCOPE_PICKLIST_COPY.DESCRIPTION_MIDDLE,
        React.createElement("b", { className: 'clickable', onClick: handleEntityClick }, parentEntity.displayName),
        PERISCOPE_PICKLIST_COPY.DESCRIPTION_SUFFIX));
};
